const inkeep_ai_bot = {
    intro_message: 'สวัสดี ฉันคือ Logto AI!\n\nฉันเป็นผู้ช่วย AI ที่ได้รับการฝึกฝนด้วยเอกสาร คู่มือช่วยเหลือ และเนื้อหาอื่น ๆ\n\nถามฉันเกี่ยวกับ `Logto` ได้ทุกเรื่อง',
    chat_placeholder: 'ถามคำถาม Logto AI ของคุณเพื่อรับคำแนะนำทีละขั้นตอน',
    disclaimer_label: 'ข้อจำกัดความรับผิดชอบของ Logto AI',
    disclaimer_tooltip: 'คำตอบถูกสร้างโดย AI และอาจต้องตรวจสอบความถูกต้องเพิ่มเติม',
    example_questions_label: 'ตัวอย่างคำถาม',
    example_questions: [
        'คู่มือเริ่มต้นสำหรับการตั้งค่า Logto',
        'การตั้งค่าสถาปัตยกรรมหลายผู้เช่า',
        'จะเชื่อมต่อโปรไฟล์ผู้ใช้งานได้อย่างไร?',
    ],
    stop: 'หยุด',
    clear: 'เริ่มใหม่',
    get_help: 'ขอความช่วยเหลือ',
    copy_chat: 'คัดลอก',
    ask_ai_label: 'ถาม AI',
    contact: 'ติดต่อ',
    discord: 'Discord',
};
export default Object.freeze(inkeep_ai_bot);
